module.exports = __webpack_public_path__ + "img/liantong.e901a125.png";